function strToEnum<T>(str: string) {
  return str.toUpperCase().replaceAll("-", "_") as T;
}

function enumToStr<T>(str: string) {
  return str.toLowerCase().replaceAll("_", "-") as T;
}

export { enumToStr, strToEnum };
